export const ROUTES = {
  NotFound: "/not_found",
  ROOT: "/",
  PERMISSIONS: "/permissions",
  PERMISSIONS_DECLINED: "/permissions_declined",
  LAUNCH: "/launch",
  LOGIN: "/login",
  LOGIN_OTP: "/login_otp",
  HOME: "/home",
  ONBOARDING_HOME: "/onboarding_home",
  APP_INITIALIZER: "/appInitializer",
  CREDIT_REPORT: "/credit_report",
  CREDIT_REPORT_PAYMENT: "/credit_report_payment",
  CREDIT_REPORT_PAYMENT_SUCCESS: "/credit_report_payment_success",
  CREDIT_REPORT_PAYMENT_APOLOGY: "/credit_report_payment_apology",
  PROFILE: "/profile",
  REJECT: "/reject",
  MANUAL_REVIEW: "/manual_review",
  UNIFIED_KYC_MANUAL: "/unified_kyc_manual",
  // Stage 1
  EMAIL_VERIFICATION: "/email_verification",
  PERSONAL_DETAILS: "/personal_details",
  PAN_CHECK_PENDING: "/pan_check_pending",
  PAN_CHECK_FAILED: "/pan_check_failed",
  INCOME_INFO: "/income_details",
  ADDRESS_DETAILS: "/address_details",
  ELIGIBILITY_CHECK_PENDING: "/eligibility_check_pending",
  //Stage 2
  REFERENCE_VERIFICATION: "/reference_verification",
  KYC_VERIFICATION: "/kyc_verification",
  UPLOAD_DOCUMENTS: "/upload_documents",
  REUPLOAD_DOCUMENTS: "/reupload_documents",
  VIDEO_KYC: "/video_kyc",
  KYC_CALLBACK_PENDING: "/kyc_callback_pending",
  VKYC_STATUS_PENDING: "/vkyc_status_pending",
  // Boosters
  NEXT_STEPS: "/next_steps",
  MOBILE_AUTH: "/mobile_auth",
  EMPLOYMENT_VALIDATION: "/employment_validation",
  INCOME_VALIDATION_OPTIONS: "/income_validation_options",
  BANK_STATEMENT_VALIDATION: "/bank_statement_validation",
  UPLOAD_PAYSLIPS: "/upload_payslips",
  UPLOAD_BANK_STATEMENT: "/upload_bank_statement",
  HANDLE_UNIFIED_KYC: "/handleUnifiedKYC",
  UNIFIED_KYC_WAITING: "/unified_kyc_waiting_screen",
  HOUSEHOLD_INCOME_DECLARATION: "/household_income_declaration",
  ADDRESS_VALIDATION_STAGE4: "/address_validation_stage4",
  CKYC_CONSENT: "/ckyc_consent",
  CKYC_DETAILS: "/ckyc_details",
  STAGE3_BOOSTERS: "/boosters",
  //stage 3
  LOAN_PLAN: "/loan_plan",
  LOAN_SUMMARY: "/loan_summary",
  COUPON: "/coupon",
  LOAN_PURPOSE: "/loan_purpose",
  RE_EVALUATION: "/re_evaluation",
  CONGRATULATIONS: "/congratulations",
  //stage 4
  ADD_BANK_ACCOUNT: "/add_bank_account",
  SELECT_BANK_ACCOUNT: "/select_bank_account",
  PENNY_DROP_CHECK_PENDING: "/penny_drop_check_pending",
  LOAN_SANCTION_LETTER: "/loan_sanction_letter",
  SIGN_LOAN_AGREEMENT: "/sign_loan_agreement",
  ESIGN_AGREEMENT: "/esign_agreement",
  LIVE_SELFIE_CAPTURE: "/live_selfie_capture",
  ESIGN_IN_PROGRESS: "/esign_in_progress",
  ESIGN_SELFIE: "/esign_selfie",
  ESIGN_FAILED: "/esign_failed",
  ESIGN_MANUAL_VERIFICATION: "/esign_manual_verification",
  ENACH_SETUP: "/enach_setup",
  ENACH_UPI_STEP: "/enach_upi_step",
  ENACH_BANK_STEP: "/enach_bank_step",
  DISBURSAL_IN_PROGRESS: "/disbursal_in_progress",

  //stage 5
  REPAYMENT_HOME: "/repayment_home",
  REPAYMENT_SCHEDULE_DETAILS: "/repayment_schedule_details",
  EMI_DETAILS: "/emi_details",
  REPAYMENT_SUCCESS: "/repayment_success",
  CLOSED_LOAN_SUCCESS: "/closed_loan_success",
  REPAYMENT_FAILED: "/repayment_failed",
  PHONEPE_CALLBACK: "/phonePe",
  //profile
  MANAGE_PROFILE: "/manage_profile",
  CONTACT_US: "/contact_us",
  LOAN_HISTORY: "/loan_history",
  DEACTIVATE_PROFILE: "/deactivate_profile",
  DEACTIVATE_PROFILE_OTP: "/deactivate_profile_otp",
  CANT_DEACTIVATE: "/cant_deactivate",
  CANT_DELETE: "/cant_delete",
  DELETE_PROFILE: "/delete_profile",
  DELETE_PROFILE_OTP: "/delete_profile_otp",
  DELETE_PROFILE_SUCCESS: "/delete_profile_success",
  DOWNLOAD_LOAN_DOCUMENT: "/download_loan_document",
  MANAGE_PERMISSIONS: "/manage_permissions",
  PROFILE_BANK_ACCOUNT: "/profile_bank_account",
  ACCOUNT_DEACTIVATED: "/account_deactivated",
};
